import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@/Config/api/queryKey';
import { CenterSpinner } from '@/Domain/components/Shared/CenterSpinner/CenterSpinner';
import { AiModelPage, type AiModelData } from '@/UI/Identity/AiModel/AiModel.page';

export const AiModelLoader = () => {
  const { data, isLoading } = useQuery<AiModelData>({ queryKey: [QueryKey.aiModel.get] });

  if (isLoading || !data) {
    return <CenterSpinner />;
  }

  return <AiModelPage data={data} />;
};
